import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory, useLocation } from "react-router-dom";

import { acceptInvitation } from "../../api/students";
import UserEmail from "../../assets/images/user-email.svg";
import Partials from "../partials";
import Blocks from "../blocks";

const PageStudentAcceptInvite = () => {
    const [isVerified, _setIsVerified] = useState(false);
    const [isLoading, _setIsLoading] = useState(true);
    const [userType, _userType] = useState('');
    const { search } = useLocation();
    const history = useHistory();

    let invitationCode = getToken(search);

    const {
        // isLoading,
        error, isError, mutate, data
    } = useMutation(acceptInvitation, {
        onSuccess: (data) => {
            if (data?.data?.body) {
                if (data?.data?.body?.user_type === "teacher") {
                    sessionStorage.setItem("teacherInfo", JSON.stringify(data.data.body))
                } else {
                    sessionStorage.setItem("stud_info", JSON.stringify(data.data.body))
                }

                _setIsVerified(true);
                _setIsLoading(false);
            }
        }, onError: (err) => {
            console.log("err", err)
            alert("We are having some problem confirming you're invitation. Please try again later.", err)
        },
    });

    const redirectUser = () => {
        if (userType === "teacher") {
            history.push("/teacher/complete-profile");
        } else {
            history.push("/student/complete-profile");
        }
    }

    // const userType = data?.data?.body?.user_attributes?.find((attr) => attr.name === "userType");
    // const userType = data?.data?.body?.user_type;

    useEffect(() => {
        mutate({ invitationCode: invitationCode });

    }, [])

    useEffect(() => {
        if (data?.data?.body) {
            _userType(data?.data?.body?.user_type)
        }
    }, [data]);


    return (<div className={'page PageVerifyEmail'}>
        <div className="container mx-auto">
            <div className="flex flex-col md:flex-row items-center">
                <div className="bgWrapper md:flex flex-1 justify-center items-center bg-white">
                    <img src={UserEmail} alt="" draggable={false} />
                </div>
                <div
                    className="pageContent w-full flex-1 text-center mx-auto md:mr-0 md:ml-auto mb-4 bg-white p-4 rounded-xl">
                    <Blocks.ErrorBoundary>
                        {isLoading ?
                            <Partials.PartialLoading classes="text-black" />
                            : isVerified ? <>

                                <Partials.PartialSuccessIcon />
                                <h3 className={"text-xl md:text-4xl mb-8 font-['Poppins-SemiBold']"}>Verified</h3>
                                <p className={"text-md md:text-xl leading-loose mb-10"}>
                                    <span className={"leading-loose"}>
                                        Your email address has been verified.
                                    </span>
                                </p>
                                <button
                                    className="bg-black hover:bg-slate-600 text-white font-bold py-3 px-16 rounded focus:outline-none focus:shadow-outline"
                                    onClick={() => redirectUser()}>
                                    {userType?.value === "teacher" ? "Login" : "Complete Profile"}
                                </button>
                            </> : <>
                                <Partials.PartialFailureicon />
                                <h3 className={"text-xl md:text-4xl mb-8 font-['Poppins-SemiBold']"}>Not Verified</h3>
                                <p className={"text-md md:text-xl leading-loose mb-10"}>
                                    <span className={"leading-loose"}>
                                        Your email address has not been verified.
                                    </span>
                                </p>
                            </>
                        }
                    </Blocks.ErrorBoundary>
                </div>
            </div>
        </div>
    </div>)
}

export default PageStudentAcceptInvite;

const getToken = (qString) => {
    const result = {};
    qString.slice(1).split('&').map(str => {
        let indexOfEq = str.indexOf("=")
        let key = str.slice(0, indexOfEq);
        0
        let value = str.slice(indexOfEq + 1)

        result[key] = value;
    })

    return result["invitation-code"]
}
